import { motion } from "framer-motion";

import entertainmentImage from "./assets/entertainment.webp";

const HeroSection = () => {
  return (
    <section className="bg-black text-white min-h-screen flex flex-col-reverse lg:flex-row items-center justify-between px-6 lg:px-20 relative z-10 overflow-hidden">
      {/* Left: Text + gradient blur background */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left relative z-10 py-12">
        {/* Blurred gradient background layer */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#EF3BF2] via-[#7B41E6] to-black blur-3xl opacity-60 z-0" />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="relative z-10"
        >
          <p className="text-sm font-medium text-white/70 uppercase tracking-wide mb-4">
            Entertainment
          </p>
          <h1 className="text-[32px] sm:text-[40px] lg:text-[48px] font-bold leading-tight mb-6">
            Excitement meets <br /> unforgettable experiences
          </h1>
          <p className="text-base sm:text-lg text-[#D4D4D8] max-w-xl mx-auto lg:mx-0">
            Discover a world where every moment is filled with excitement and
            unforgettable experiences that inspire, entertain and connect.
          </p>
        </motion.div>
      </div>

      {/* Right: Image with animation */}

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        viewport={{ once: true }}
        className="w-full lg:w-1/2 flex justify-center lg:justify-end"
      >
        <div className="relative w-[100px] h-[300px] sm:h-[400px] sm:w-[400px] md:h-[400px] lg:h-auto lg:min-h-screen lg:absolute lg:top-0 lg:bottom-0 lg:right-0 lg:w-1/2">
          <img
            src={entertainmentImage}
            alt="Entertainment VR"
            className="absolute top-0 right-0 bottom-0 w-full h-full object-cover"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
